import { render, staticRenderFns } from "./AffiliateAccountView.vue?vue&type=template&id=34a16284&"
import script from "./AffiliateAccountView.vue?vue&type=script&lang=js&"
export * from "./AffiliateAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a16284')) {
      api.createRecord('34a16284', component.options)
    } else {
      api.reload('34a16284', component.options)
    }
    module.hot.accept("./AffiliateAccountView.vue?vue&type=template&id=34a16284&", function () {
      api.rerender('34a16284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliateAccountView.vue"
export default component.exports